import { t } from "../lib/i18n";
import React from 'react';
import { Link } from 'react-router-dom';

interface KPISectionProps {
  title: string;
  value: string | number;
  link: string;
}

const KPISection: React.FC<KPISectionProps> = ({ title, value, link }) => {
  return (
    <div className="bg-bg-secondary p-4 rounded shadow border border-border-primary">
      <h3 className="text-lg font-semibold text-text-secondary">{title}</h3>
      <p className="text-2xl font-bold text-text-primary">{value}</p>
      <Link to={link} className="text-primary hover:underline mt-2 block">{t("kPISection.k1")}</Link>
    </div>
  );
};

export default KPISection;
